module.exports = __webpack_public_path__ + "static/media/stepper-plus.85e08e6e.svg";